import type { PanelProps } from './Panel';
import Panel from './Panel';
import type { PropsWithChildren } from 'react';

interface AnchoredPanelProps extends PanelProps {
  href: string;
}

function AnchoredPanel({
  href,
  startElement,
  endElement,
  className,
  children,
}: PropsWithChildren<AnchoredPanelProps>) {
  return (
    <a href={href} className="group block cursor-pointer">
      <Panel
        startElement={startElement}
        endElement={endElement}
        className={className}
      >
        {children}
      </Panel>
    </a>
  );
}

export default AnchoredPanel;
